(function(){

  var r=document.getElementById('uupz-exp');

  if(!r){
    return;
  }


  var tabs=r.querySelectorAll('.ex-tab'),
      panels=r.querySelectorAll('.ex-panel'),
      chips=r.querySelectorAll('.ex-chip'),
      cards=r.querySelectorAll('.c[data-t]'),
      sum=r.querySelector('#exS'),
      clr=r.querySelector('#exC'),
      grid=r.querySelector('#exG'),
      loadBtn=r.querySelector('#exLoad'),
      badges=r.querySelectorAll('[data-badge]'),
      quick=document.getElementById('exQuick'),
      qRow=document.getElementById('exQRow'),
      qPanel=document.getElementById('exQPanel');


  var lb={

    'sun':'SUN',
    'moon':'MOON',
    'star':'STAR',
    'saturn':'SATURN',
    'stellar':'STELLAR',
    'rocket':'ROCKET',
    'especiales':'ESPECIALES',

    'tapa-popote':'Tapa y popote',
    'cafetero':'Cafetero',
    'frappe':'Vaso frappé',
    'tapioca':'Vaso tapioca',
    'un-litro':'Vaso de 1 litro',
    'tipo-especial':'Con efecto',

    '12oz':'12 oz / 354 ml',
    '16oz':'16 oz / 473 ml',
    '20oz':'20 oz / 591 ml',
    '24oz':'24 oz / 709 ml',
    '34oz':'34 oz / 1 L',

    'kit-12oz':'12 oz / 354 ml',
    'kit-16oz':'16 oz / 473 ml',
    'kit-20oz':'20 oz / 591 ml',
    'kit-24oz':'24 oz / 709 ml',
    'kit-34oz':'34 oz / 1 L',

    'fiestas-tematicas':'Fiestas temáticas',
    'bodas':'Bodas',
    'gender-reveal':'Gender Reveal',
    'primera-comunion':'Primera Comunión',
    'graduacion':'Graduación',
    'navidad':'Navidad',
    'san-valentin':'San Valentín',
    'aficiones':'Aficiones'

  };


  var catNames={

    'mod':'Modelo',
    'tipo':'Tipo de vaso',
    'cap':'Capacidad',
    'kit':'Kits temáticos',
    'oca':'Ocasión'

  };


  var categories=[
    'mod',
    'tipo',
    'cap',
    'kit',
    'oca'
  ];


  function L(c){

    return lb[c.dataset.f] || c.dataset.f;

  }


  var showAll=false;

  var activeTab=null;

  var browseMode=null;

  var INITIAL_ROWS=3;


  /* =====================================================
     UUPZ | VISTA INICIAL
     Solo estos 15 vasos aparecen antes de usar filtros.
     Al activar cualquier filtro, vuelve a funcionar el
     catálogo completo con la lógica original.
  ===================================================== */

  var INITIAL_PRODUCT_HANDLES=[
    'vaso-star-12-oz-354ml',
    'vaso-sun-slim-12oz',
    'vaso-saturn-12-oz-354ml',
    'vaso-sun-16-oz-473ml',
    'mini-vaso-moon-16-oz-473-ml',
    'vaso-star-16-oz-473ml',
    'vaso-sun-slim-16oz',
    'vaso-saturn-16-oz-473ml',
    'vaso-mega-star-20-oz',
    'vaso-sun-slim-20oz',
    'vaso-mega-saturn-20-oz',
    'vaso-sun-24-oz-709ml',
    'vaso-moon-24-oz-709-ml',
    'vaso-stellar-34oz',
    'vaso-rocket-1lt'
  ];


  function cardProductHandle(card){

    var link=
      card.querySelector(
        '.c-link'
      );


    if(!link){
      return '';
    }


    var href=
      link.getAttribute('href') || '';


    href=
      href
      .split('?')[0]
      .split('#')[0]
      .replace(/\/$/,'');


    var marker='/products/';

    var pos=
      href.indexOf(
        marker
      );


    if(pos===-1){
      return '';
    }


    return href.substring(
      pos + marker.length
    );

  }


  function isInitialProduct(card){

    return INITIAL_PRODUCT_HANDLES.indexOf(
      cardProductHandle(card)
    )>-1;

  }


  function colsPerRow(){

    var w=r.offsetWidth;

    if(w>=900){
      return 4;
    }

    if(w>=550){
      return 3;
    }

    return 2;

  }


  function initialLimit(){

    return colsPerRow()*INITIAL_ROWS;

  }


  function activeCat(cat){

    var n=0;


    chips.forEach(function(c){

      if(
        c.dataset.c===cat &&
        c.classList.contains('on')
      ){
        n++;
      }

    });


    return n;

  }


  function getSelections(){

    var selections={
      'mod':[],
      'tipo':[],
      'cap':[],
      'kit':[],
      'oca':[]
    };


    chips.forEach(function(c){

      if(c.classList.contains('on')){

        selections[c.dataset.c].push(
          c.dataset.f
        );

      }

    });


    return selections;

  }


  function hasAnyFilter(selections){

    return categories.some(function(cat){

      return selections[cat].length>0;

    });

  }


  function cardMatchesBrowseMode(cardTags){

    if(browseMode==='kit'){

      return (
        cardTags.indexOf('kits-armados')>-1 &&
        cardTags.indexOf('fiestas-tematicas')>-1
      );

    }


    if(browseMode==='oca'){

      var occasionTags=[
        'fiestas-tematicas',
        'bodas',
        'gender-reveal',
        'primera-comunion',
        'graduacion',
        'navidad',
        'san-valentin',
        'aficiones'
      ];


      return occasionTags.some(function(tag){

        return cardTags.indexOf(tag)>-1;

      });

    }


    return true;

  }


  function updateBadges(){

    badges.forEach(function(b){

      var cat=b.dataset.badge;

      var n=activeCat(cat);

      var tab=b.closest('.ex-tab');


      b.textContent=n;


      if(n>0){

        tab.classList.add(
          'has-active'
        );

      }else{

        tab.classList.remove(
          'has-active'
        );

      }

    });

  }


  function syncQuick(){

    if(!quick){
      return;
    }


    var qTabs=
      quick.querySelectorAll(
        '.ex-qtab'
      );


    qTabs.forEach(function(q){

      var cat=q.dataset.qcat;


      if(activeTab===cat){

        q.classList.add(
          'active'
        );

      }else{

        q.classList.remove(
          'active'
        );

      }


      if(activeCat(cat)>0){

        q.classList.add(
          'has-filter'
        );

      }else{

        q.classList.remove(
          'has-filter'
        );

      }

    });


    var qChips=
      quick.querySelectorAll(
        '.ex-qchip'
      );


    qChips.forEach(function(qc){

      var original=
        r.querySelector(
          '.ex-chip[data-c="'+
          qc.dataset.qcat+
          '"][data-f="'+
          qc.dataset.qf+
          '"]'
        );


      if(
        original &&
        original.classList.contains('on')
      ){

        qc.classList.add('on');

      }else{

        qc.classList.remove('on');

      }

    });

  }


  function cardMatchesSelections(
    cardTags,
    selections
  ){

    for(
      var i=0;
      i<categories.length;
      i++
    ){

      var cat=
        categories[i];


      var selected=
        selections[cat];


      if(selected.length===0){
        continue;
      }


      var match=
        selected.some(function(tag){

          return cardTags.indexOf(tag)>-1;

        });


      if(!match){

        return false;

      }

    }


    return true;

  }


  function A(){

    updateBadges();


    var selections=
      getSelections();


    var anyFilter=
      hasAnyFilter(
        selections
      ) ||
      browseMode!==null;


    var labels=[];


    if(browseMode==='kit'){

      labels.push(
        'Kits temáticos'
      );

    }else if(browseMode==='oca'){

      labels.push(
        'Ocasión'
      );

    }


    categories.forEach(function(cat){

      selections[cat].forEach(
        function(f){

          labels.push(
            lb[f] || f
          );

        }
      );

    });


    var limit=
      !anyFilter
      ?
      (
        showAll
        ?
        Infinity
        :
        4
      )
      :
      (
        showAll
        ?
        Infinity
        :
        initialLimit()
      );


    var matching=0;

    var visible=0;


    var orderedCards=
      Array.prototype.slice.call(
        cards
      );


    orderedCards.sort(function(a,b){

      var ap=
        parseInt(
          a.getAttribute('data-priority'),
          10
        ) || 500;


      var bp=
        parseInt(
          b.getAttribute('data-priority'),
          10
        ) || 500;


      return ap-bp;

    });


    orderedCards.forEach(function(card,index){

      card.style.order=index;


      var cardTags=
        (card.dataset.t||'')
        .split(' ')
        .filter(function(tag){
          return tag!=='';
        });


      var show=
        cardMatchesSelections(
          cardTags,
          selections
        );


      if(show){

        show=
          cardMatchesBrowseMode(
            cardTags
          );

      }


      /* Sin filtros: mostrar únicamente los 15 vasos principales.
         Con cualquier filtro activo: no aplicar esta restricción. */
      if(
        show &&
        !anyFilter
      ){

        show=
          isInitialProduct(
            card
          );

      }


      if(show){

        matching++;


        if(visible<limit){

          card.style.display='';

          visible++;

        }else{

          card.style.display='none';

        }

      }else{

        card.style.display='none';

      }

    });


    var empty=
      r.querySelector(
        '.ex-empty'
      );


    if(matching===0){

      if(!empty){

        empty=
          document.createElement(
            'div'
          );


        empty.className=
          'ex-empty';


        empty.innerHTML=
          '<strong>Sin resultados</strong> '+
          'Prueba quitando alguno de los filtros.';


        grid.appendChild(
          empty
        );

      }

    }else if(empty){

      empty.remove();

    }


    if(!anyFilter){

      if(
        showAll ||
        matching<=visible
      ){

        sum.innerHTML=
          'Mostrando <strong>'+
          matching+
          ' productos</strong>';

      }else{

        sum.innerHTML=
          'Mostrando <strong>'+
          visible+
          ' de '+
          matching+
          ' productos</strong>';

      }


      clr.style.display='none';

    }else{

      if(
        showAll ||
        matching<=visible
      ){

        sum.innerHTML=
          '<strong>'+
          matching+
          ' productos</strong> · '+
          labels.join(' · ');

      }else{

        sum.innerHTML=
          '<strong>'+
          visible+
          ' de '+
          matching+
          ' productos</strong> · '+
          labels.join(' · ');

      }


      clr.style.display='';

    }


    loadBtn.hidden=
      !(
        !showAll &&
        matching>visible
      );


    syncQuick();

  }


  tabs.forEach(function(tab){

    tab.addEventListener(
      'click',
      function(){

        var name=
          tab.dataset.tab;


        if(activeTab===name){

          tab.classList.remove(
            'active'
          );


          panels.forEach(function(panel){

            if(
              panel.dataset.panel===name
            ){

              panel.classList.remove(
                'open'
              );

            }

          });


          activeTab=null;

          browseMode=null;

        }else{


          tabs.forEach(function(t){

            t.classList.remove(
              'active'
            );

          });


          panels.forEach(function(panel){

            panel.classList.remove(
              'open'
            );

          });


          tab.classList.add(
            'active'
          );


          panels.forEach(function(panel){

            if(
              panel.dataset.panel===name
            ){

              panel.classList.add(
                'open'
              );

            }

          });


          activeTab=name;

          browseMode=
            (
              name==='kit' ||
              name==='oca'
            )
            ?
            name
            :
            null;

        }


        showAll=false;

        A();

      }
    );

  });


  chips.forEach(function(chip){

    chip.addEventListener(
      'click',
      function(){

        showAll=false;


        var wasActive=
          chip.classList.contains(
            'on'
          );


        /* En cada sección solo puede existir un filtro activo.
           Sí se pueden combinar filtros de secciones diferentes. */
        chips.forEach(function(otherChip){

          if(
            otherChip.dataset.c===
            chip.dataset.c
          ){

            otherChip.classList.remove(
              'on'
            );


            otherChip.innerHTML=
              L(otherChip);

          }

        });


        if(!wasActive){

          chip.classList.add(
            'on'
          );


          chip.innerHTML=
            L(chip)+
            ' <span class="ex-chip-x">✕</span>';

        }


        A();

      }
    );

  });


  clr.addEventListener(
    'click',
    function(e){

      e.preventDefault();


      showAll=false;

      browseMode=null;


      chips.forEach(function(chip){

        chip.classList.remove(
          'on'
        );


        chip.innerHTML=
          L(chip);

      });


      A();

    }
  );


  loadBtn.addEventListener(
    'click',
    function(){

      showAll=true;

      A();

    }
  );


  function buildQuick(){

    if(
      !quick ||
      !qRow ||
      !qPanel
    ){
      return;
    }


    qRow.innerHTML='';

    qPanel.innerHTML='';


    categories.forEach(
      function(cat,index){

        var btn=
          document.createElement(
            'button'
          );


        btn.type='button';

        btn.className=
          'ex-qtab';

        btn.dataset.qcat=
          cat;


        btn.innerHTML=
          catNames[cat]+
          '<span class="ex-qdot"></span>';


        btn.addEventListener(
          'click',
          function(){

            openQuickCategory(
              cat,
              false
            );

          }
        );


        qRow.appendChild(
          btn
        );


        if(
          index<
          categories.length-1
        ){

          var sep=
            document.createElement(
              'span'
            );


          sep.className=
            'ex-qsep';


          sep.innerHTML='|';


          qRow.appendChild(
            sep
          );

        }

      }
    );


    syncQuick();

  }


  function openQuickCategory(
    cat,
    forceOpen
  ){

    if(!qPanel){
      return;
    }


    if(
      !forceOpen &&
      qPanel.classList.contains('open') &&
      qPanel.dataset.cat===cat
    ){

      qPanel.classList.remove(
        'open'
      );

      qPanel.innerHTML='';

      activeTab=null;

      browseMode=null;

      showAll=false;

      A();

      return;

    }


    activeTab=cat;

    browseMode=
      (
        cat==='kit' ||
        cat==='oca'
      )
      ?
      cat
      :
      null;

    showAll=false;


    qPanel.innerHTML='';

    qPanel.dataset.cat=cat;


    var originals=
      r.querySelectorAll(
        '.ex-chip[data-c="'+
        cat+
        '"]'
      );


    originals.forEach(
      function(original){

        var q=
          document.createElement(
            'button'
          );


        q.type='button';

        q.className=
          'ex-qchip';

        q.dataset.qcat=
          cat;

        q.dataset.qf=
          original.dataset.f;


        q.innerHTML=
          L(original);


        if(
          original.classList.contains(
            'on'
          )
        ){

          q.classList.add('on');

        }


        q.addEventListener(
          'click',
          function(){

            original.click();


            openQuickCategory(
              cat,
              true
            );

          }
        );


        qPanel.appendChild(
          q
        );

      }
    );


    qPanel.classList.add(
      'open'
    );


    A();

  }


  function quickTop(){

    var top=8;


    var selectors=[
      '.tt-stuck-nav',
      '.tt-mobile-header',
      '.tt-header',
      'header'
    ];


    for(
      var i=0;
      i<selectors.length;
      i++
    ){

      var h=
        document.querySelector(
          selectors[i]
        );


      if(!h){
        continue;
      }


      var style=
        window.getComputedStyle(h);


      var rect=
        h.getBoundingClientRect();


      if(
        (
          style.position==='fixed' ||
          style.position==='sticky'
        ) &&
        rect.bottom>0 &&
        rect.bottom<220
      ){

        top=
          Math.max(
            top,
            rect.bottom+8
          );


        break;

      }

    }


    return top;

  }


  function positionQuick(){

    if(!quick){
      return;
    }


    var rr=
      r.getBoundingClientRect();


    var viewport=
      document.documentElement.clientWidth;


    var width=
      viewport<768
      ?
      Math.min(
        rr.width,
        viewport-16
      )
      :
      Math.min(
        rr.width,
        980,
        viewport-32
      );


    var left=
      (viewport-width)/2;


    if(left<8){
      left=8;
    }


    quick.style.width=
      width+'px';


    quick.style.left=
      left+'px';


    quick.style.top=
      quickTop()+'px';

  }


  var lastY=
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    0;


  function handleQuickScroll(){

    var y=
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;


    var delta=
      y-lastY;


    var rootRect=
      r.getBoundingClientRect();


    var summaryRect=
      sum.getBoundingClientRect();


    var passed=
      summaryRect.top<
      quickTop();


    var inside=
      rootRect.bottom>120 &&
      rootRect.top<0;


    if(
      passed &&
      inside &&
      delta<-4
    ){

      positionQuick();

      quick.classList.add(
        'show'
      );


      quick.setAttribute(
        'aria-hidden',
        'false'
      );

    }


    if(
      delta>4 ||
      !inside
    ){

      quick.classList.remove(
        'show'
      );


      quick.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    lastY=y;

  }


  window.addEventListener(
    'scroll',
    function(){

      window.requestAnimationFrame(
        handleQuickScroll
      );

    },
    {
      passive:true
    }
  );


  window.addEventListener(
    'resize',
    function(){

      positionQuick();

      A();

    }
  );


  buildQuick();

  A();

})();